// extracted by mini-css-extract-plugin
module.exports = {"root":"ThreadHotPost_root__67S5P","title":"ThreadHotPost_title__k0Jev","list":"ThreadHotPost_list__VHdJp","post":"ThreadHotPost_post__FuG4j"};